'use client';

import { X } from 'lucide-react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface SaleConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const SaleConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
}: SaleConfirmationModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        hideCloseButton
        className="sm:max-w-[500px] !rounded-2xl p-6 bg-white flex flex-col gap-0"
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-[10px] top-[10px] text-[#575E74]"
        >
          <X className="h-5 w-5" />
        </button>

        <DialogHeader className="relative flex items-center justify-center space-y-0">
          <DialogTitle className="text-xl font-semibold text-[#1B1D22] text-center leading-6">
            Вы подтверждаете, что произведение соответствует правилам платформы?
          </DialogTitle>
        </DialogHeader>

        {/* Buttons */}
        <div className="mt-6 flex justify-center gap-10">
          <Button
            onClick={onClose}
            className="w-[155px] h-[40px] bg-[#F2F3F7] hover:bg-[#e0e0e0] text-[#1B1D22] rounded-[12px]"
          >
            Нет
          </Button>
          <Button
            onClick={onConfirm}
            className="w-[155px] h-[40px] bg-[#505CFF] hover:bg-[#505CFF]/90 text-white rounded-[12px]"
          >
            Да
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
